import React, { Component } from "react";
import { render } from 'react-dom';
import { Steps } from 'primereact/steps';
import { Growl } from "primereact/growl";
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';

import FullCalendar from '@fullcalendar/react' // must go before plugins


import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';

import allLocales from '@fullcalendar/core/locales-all';

import { Formik, Form, Field, FieldArray } from 'formik';
import { FormElements } from "./FormElements";
import { Dropdown } from 'primereact/dropdown';

import Recaptcha from "react-recaptcha";


import { EventService } from '../service/EventService';
import { CalendarService } from "../service/CalendarService";
import { QuestionService } from "../service/QuestionService";
import { NotificationService } from "../service/NotificationService";

import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import moment from "moment";
import * as Yup from "yup";
import { populateEvents } from "../helpers/populateEvents";


export class EmptyPage extends Component {

  constructor() {
    super();
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 1 : year;


    this.state = {
      // magacini su lokacije
      warehousesList: [],
      activeIndex: 0,
      selectedCity: null,
      selectedLocation: null,
      selectedLocationID: null,
      selectedCalendar: null,
      selectedCalendarID: null,
      selectedTerm: null,
      selectedTermID: null,

      items: [
        { label: 'Grad' },
        { label: 'Lokacija' },
        { label: 'Termin' },
        { label: 'Upitnik' }
      ],


    };

    // magacini


    this.eventService = new EventService();
    this.calendarService = new CalendarService();
    this.questionService = new QuestionService();
    this.notificationService = new NotificationService();


    this.locationTemplate = this.locationTemplate.bind(this);
    this.cityTemplate = this.cityTemplate.bind(this);
    this.onLocationSelect = this.onLocationSelect.bind(this);
    this.onCitySelect = this.onCitySelect.bind(this);
    this.onTermSelect = this.onTermSelect.bind(this);


    this.eventService = new EventService();
    this.getQuestionFootnote = this.getQuestionFootnote.bind(this);
    this.getQuestionName = this.getQuestionName.bind(this);
    this.allRequired = this.allRequired.bind(this);

    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {

    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);


    this.questionService.getQuestions().then(data => this.setState({ questions: data }));


    this.calendarService.getCalendars().then(data => {

      this.setState({ calendars: data });

      const _warehousesList = data.map((a) => {

        const container = {};
        container.label = a.warehouse.wh_name;
        container.adress = a.warehouse.wh_adress;
        container.city = a.warehouse.wh_city;
        container.phone = a.warehouse.wh_phone;
        container.value = a.warehouse_id;
        container.key = a.warehouse_id;
        return container;

      });

      this.setState({ warehousesList: _warehousesList });

      const key = 'city';
      const _city = _warehousesList.map(function (d) { return d[key]; }).filter((v, i, a) => a.indexOf(v) === i);
      const unique = _city.map(function (d) { return { label: d, key: d }; }).filter((v, i, a) => a.indexOf(v) === i);
      this.setState({ citys: unique });

    });


  }

  // proverava da li su svi uneti
  allRequired(valuses) {


    const validateRequire = valuses.ceventanswers_set.filter((a) => {

      if (a.required_field) {
        if (a.answer) { return false } else { return true }
      }
      else return false;

    })
    if (validateRequire.length) {
      console.log('fali', validateRequire.length);
      return false;
    } else {
      return true;
    }
  }

  onCitySelect(e) {

    const _city = e.value;
    if (_city) {
      this.setState({ selectedCity: _city })
      // kreira listu lokacija 
      const _locations = this.state.warehousesList.filter((a) => a.city === _city);
      this.setState({ locationInCity: _locations })
      this.setState({ activeIndex: 1 });
      // this.setState({ selectedLocation: _locations, selectedLocationID: _locations.value })
    }
  }


  onLocationSelect(e) {

    const _location = e;
    console.log('TEST', e);
    if (_location) {


      this.setState({ selectedLocationID: _location.value })

      const _selectedLocation = this.state.warehousesList.filter((a) => a.value === _location.value)
      this.setState({ selectedLocation: _selectedLocation[0] })
      // zatim ucitava kalendar
      // i termine za taj kalendar
      // uzima kalendar na osnovu ID magacina

      this.calendarService.getCalendarsByWh(_location.value).then((data) => {
        const calendars = data.map((cal) => {

          const _calendar = {};

          _calendar.name = cal.calendar_name;
          _calendar.code = cal.id;
          _calendar.start_days = cal.start_days;
          _calendar.end_days = cal.end_days;
          _calendar.event_duration_calendar = cal.event_duration_calendar;

          _calendar.label = cal.calendar_name;
          _calendar.max_event_number = cal.max_event_number;
          const _businessHours = cal.cbusinesshours_set.map((bh) => {
            const _bh = {};
            // prepravka malih slova u camelcase
            _bh.daysOfWeek = bh.daysofweek;
            _bh.startTime = bh.starttime;
            _bh.endTime = bh.endtime;
            _bh.break_start_time = bh.break_start_time;
            _bh.break_end_time = bh.break_end_time;

            return _bh;
          });

          _calendar.businessHours = _businessHours

          return _calendar;

        });
        this.setState({ selectedCalendar: calendars[0] })

        if (calendars[0]) {

          this.eventService.getEventsByCalendar(calendars[0].code).then(data => {
            // ovde treba funkcija koja vraca listu eventa
            // sa statusima
            const _events = populateEvents(data, calendars[0])
            this.setState({ events: _events });
            this.setState({ activeIndex: 2 });

          });
        } else {
          this.growl.show({ severity: 'warn', summary: 'Ova lokacija nema dostupan kalendar', detail: 'Prepraviti api' });
        }
      }).catch((e) => {
        if (e.response) {
          // console.log('GRESKA', e.response);
        }
      });

    }

  }

  onTermSelect(e, c) {

    const _start = e.event.start;

    if (e.event.extendedProps.disabled) {
      const durationMinutes = parseInt(c.event_duration_calendar, 10) || 30;

      const ceventanswersSet = this.state.questions.map((q) => {
        const _answer = {};
        _answer.question = q.id;
        _answer.order_number = q.question_order;
        _answer.answer = q.dafault_answer;
        _answer.active = true;
        _answer.required_field = q.required_field;
        _answer.user_created_id = 1;
        _answer.created_dt = moment().format();
        _answer.user_last_modf_id = 1;
        _answer.last_modif_dt = moment().format();
        _answer.tenant_id = 1;

        return _answer;
      })

      const newEvent = {
        "ceventanswers_set": [],
        "calendar": c.code, // defaultni kalendar
        "term": 1,
        "date": 20210107, // zakucano treba skloniti
        "title": "Zahtev sa sajta",
        "event_start": e.start,
        "event_end": moment(e.start).add(durationMinutes, 'minutes'),
        "status": 2,
        "accepted": moment(),
        "user_accepted_id": 1,
        "user_created_id": 1,
        "created_dt": moment(),
        "user_last_modf_id": 1,
        "last_modif_dt": moment(),
        "tenant_id": 1
      };

      // console.log("CES", ceventanswersSet);

      newEvent.ceventanswers_set = ceventanswersSet;
      newEvent.event_start = _start;
      newEvent.event_end = moment(_start).add(durationMinutes, 'minutes');
      this.setState({ selectedTerm: newEvent })
      this.setState({ activeIndex: 3 });
    } else {
      this.growl.show({ severity: 'warn', summary: 'Ovaj termin je zauzet', detail: 'Odaberite drugi termin' });
    }
  }


  cityTemplate(option) {
    const logoPath = 'assets/layout/images/v-city.png';

    return (
      <div style={{ textAlign: 'center', padding: '1em', width: '125px' }}>
        <img alt={option.label} src={logoPath} style={{ height: '48px' }} />
        <div style={{ marginTop: '1em' }}>{option.label}</div>
      </div>
    )
  }

  locationTemplate(option) {
    const logoPath = 'assets/layout/images/v-location.png';

    return (
      <div style={{ textAlign: 'center', padding: '1em', width: '125px' }}>
        <img alt={option.label} src={logoPath} style={{ height: '48px' }} />
        <div style={{ marginTop: '1em' }}>{option.label}</div>
      </div>
    )
  }

  carTemplate(option) {
    const logoPath = 'showcase/demo/images/car/' + option.brand + '.png';

    return (
      <div style={{ textAlign: 'center', padding: '1em', width: '125px' }}>
        <img alt={option.brand} src={logoPath} srcSet="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png" style={{ width: '48px' }} />
        <div style={{ marginTop: '1em' }}>{option.brand}</div>
      </div>
    )
  }



  // pamcenje
  onSave(data) {

    this.eventService.createEvent(data)
      .then((res) => {
        this.growl.show({ severity: 'success', summary: 'Uspešno', detail: 'Zahtev uspešno poslat' });

        // treba da izvuce mail iz liste odgovora
        const clientText = "Poštovani, Uspešno ste poslali zahtev za zakazivanje termina. Uskoro će Vas neko kontaktirati radi potvrde. Hvala na poverenju!";
        const adminText = "Pristigao je novi zahtev";
        // treba da pošalje obavestenje klijentu
        this.notificationService.sendNotification('Potvrda slanja zahteva', clientText, 'ivana.mitrovic@diginout.com');
        // treba da pošalje obavestenje nekom iz pneumastera
        this.notificationService.sendNotification('Novi zahtev', adminText, 'nikola.tomic@diginout.com');
        this.setState({ activeIndex: 4 });

      })
      .catch((e) => {
        if (e.response) {
          // console.log('GRESKA', e.response);
        }
      });
  }


  getQuestionName = (id) => {

    let filtered = this.state.questions.filter(a => a.id == id);
    if (filtered[0]) {
      return filtered[0].question_name;
    } else {
      return ''
    }
  }

  getQuestionFootnote = (id) => {
    let filtered = this.state.questions.filter(a => a.id == id);
    if (filtered[0]) {
      return filtered[0].footnote;
    } else {
      return ''
    }
  }

  render() {



    const logo = 'assets/layout/images/demo-logo.png';

    const interactiveItems = [{
      label: this.state.items[0].label,
      command: (event) => {
        // console.log(event);
        // this.growl.show({ severity: 'warn', summary: this.state.items[0].label, detail: event.item.label });
      }
    },
    {
      label: this.state.items[1].label,
      command: (event) => {
        // this.growl.show({ severity: 'warn', summary: this.state.items[1].label, detail: event.item.label });
      }
    },
    {
      label: this.state.items[2].label,
      command: (event) => {
        // this.growl.show({ severity: 'warn', summary: this.state.items[2].label, detail: event.item.label });
      }
    },
    {
      label: this.state.items[3].label,
      command: (event) => {
        //this.growl.show({ severity: 'warn', summary: this.state.items[3].label, detail: event.item.label });
      }
    }
    ];

    return (
      <div className="p-grid ">
        <Growl ref={(el) => (this.growl = el)} />


        <div className="p-xl-2 p-lg-2 p-md-2 p-sm-12"></div>

        <div className="p-xl-8 p-lg-8 p-md-8 p-sm-12">
          <div className="p-grid">
            <div className=" p-md-6 p-sm-12">
              <img style={{ maxHeight: '100px' }} alt="Logo" src={logo} />
            </div>
            <div className=" p-md-6 p-sm-12">

              <p style={{ color: "#EE6739" }}><b>Online zakazivanje termina</b></p>
              <p>Selektovani grad: <span style={{ fontWeight: 'bold' }}>{this.state.selectedCity}</span></p>
              <p>Selektovana lokacija: <span style={{ fontWeight: 'bold' }}>
                {this.state.selectedLocation ? this.state.selectedLocation.label + ', ' + this.state.selectedLocation.adress : ''}
              </span></p>
              <p>Selektovani termin: <span style={{ fontWeight: 'bold' }}>{this.state.selectedTerm ? moment(this.state.selectedTerm.event_start).format('dddd, DD-MM-YYYY u HH:mm') : ''}</span></p>


            </div>
          </div>
          <div className="card">
            {this.state.activeIndex < 5 ?
              <Steps model={interactiveItems} className="custom-step" activeIndex={this.state.activeIndex} onSelect={(e) => this.setState({ activeIndex: e.index })} readOnly={false} />
              : ""
            }
            {this.state.activeIndex == 4 &&
              <div>
                <h3>Hvala!</h3>
                <div>Uspešno ste zakazali termin!</div>
              </div>
            }


            {this.state.activeIndex == 0 &&
              <div>
                <h3>Odaberite grad</h3>
                <SelectButton value={this.state.selectedCity} options={this.state.citys} onChange={(e) => {
                  this.onCitySelect(e);
                }} itemTemplate={this.cityTemplate} optionLabel="label" optionValue="label" />


              </div>
            }

            {this.state.locationInCity && this.state.activeIndex == 1 &&
              <div>
                <h3>Odaberite lokaciju</h3>
                <SelectButton value={this.state.selectedCalendarID} options={this.state.locationInCity}
                  onChange={(e) => { this.onLocationSelect(e); }}
                  itemTemplate={this.locationTemplate} optionLabel="label" optionValue="value" />
              </div>
            }
            {this.state.selectedCalendar && this.state.activeIndex == 2 &&
              <div>
                <h3>Odaberite termin</h3>

                <FullCalendar
                  firstDay={1}
                  events={this.state.events}
                  plugins={[dayGridPlugin, timeGridPlugin]}
                  defaultView='timeGridWeek'
                  defaultDate={moment(new Date()).add(this.state.selectedCalendar.start_days + 1, 'd').format()}
                  locales={allLocales}
                  locale='sr'
                  dropAccept=".with-calendar"

                  minTime="08:30"
                  maxTime="20:30"


                  header={{
                    left: 'prev',
                    center: 'title',
                    right: 'next'
                  }}
                  // ref={calendarComponentRef}
                  editable={false}
                  selectable={true}
                  businessHours={this.state.selectedCalendar.businessHours}
                  eventConstraint={this.state.selectedCalendar.businessHours}
                  droppable={false}
                  allDaySlot={false}
                  slotDuration="01:00:00"
                  eventClick={(e) => {

                    // console.log(e);
                    this.onTermSelect(e, this.state.selectedCalendar);

                  }}
                />

              </div>
            }

            {this.state.selectedTerm && this.state.activeIndex == 3 &&
              <div>
                <h3>Upitnik</h3>
                <Formik

                  initialValues={this.state.selectedTerm ? this.state.selectedTerm : {}}
                  enableReinitialize
                  validationSchema={Yup.object().shape({
                    recaptcha: Yup.string().required(),
                  })}
                  onSubmit={(values, actions, setErrors) => {
                    switch (values.btnAction) {
                      case "SAVE":
                        if (this.allRequired(values)) {
                          this.onSave(values);
                        } else {
                          this.growl.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Morate popuniti sva obavezna polja!' });
                        }
                        break;
                      default: return false;
                    }

                  }

                  }
                >
                  {this.state.selectedTerm ? ({ values,
                    setFieldValue,
                    dirty,
                    handleSubmit,
                    errors,
                    touched,
                    setErrors,
                    meta
                  }) => (
                    <Form id="formid">

                      <div className="p-grid">
                        <div className="p-col">
                          <div className="p-fluid">


                          </div>
                          <br></br>
                          <FieldArray
                            name="ceventanswers_set"
                            render={arrayHelpers => (
                              <div className="p-fluid">
                                {values.ceventanswers_set && values.ceventanswers_set.length > 0 ? (
                                  values.ceventanswers_set.map((ceventanswers_set, index) => (

                                    <div key={index} className="p-field p-grid">
                                      <label htmlFor={`ceventanswers_set.${index}.answer`} className="p-col-12 p-md-6">
                                        {this.getQuestionName(ceventanswers_set.question)}

                                        {ceventanswers_set.required_field ? <span style={{ color: "red" }}>*</span> : ''}
                                      </label>
                                      <div className="p-col-12 p-md-6">
                                        <Field
                                          name={`ceventanswers_set.${index}.answer`}
                                          id={`ceventanswers_set.${index}.answer`}
                                          questions={this.state.questions}
                                          question_id={ceventanswers_set.question}
                                          component={FormElements}
                                        />
                                        <small>{this.getQuestionFootnote(ceventanswers_set.question)}</small>
                                      </div>

                                    </div>

                                  ))
                                ) : (
                                  ''
                                )}
                                <div>

                                </div>
                              </div>
                            )}
                          />
                          <Recaptcha
                            sitekey="6LeSy6sbAAAAAH5H3qCFc-r_2nX6TVgZNlZetqBC"
                            render="explicit"
                            verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                            onloadCallback={() => { console.log("done loading!"); }}
                          />
                          {errors.recaptcha
                            && touched.recaptcha && (
                              <p>{errors.recaptcha}</p>
                            )}
                        </div>

                      </div>
                      <div className="p-grid">
                        <div className="p-col">

                          <Button type="submit" disabled={!dirty} label="Zakaži termin" icon="pi pi-check" className="p-button-text" onClick={(e) => {
                            setFieldValue("btnAction", "SAVE");
                            handleSubmit(e);
                          }} />
                        </div>
                      </div>
                      {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    </Form>
                  ) : ''}
                </Formik></div>
            }

          </div>
        </div>
        <div className=" p-xl-2 p-lg-2 p-md-2 p-sm-12"></div>
        {/* <pre>{JSON.stringify(this.state.questions, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
      </div>
    );
  }
}
